(() => {
  if (window.__vaCollectionReturnInitialized) return;
  window.__vaCollectionReturnInitialized = true;

  const getCollectionCardFromHash = () => {
    const id = new URL(window.location.href).hash.slice(1);
    return id.startsWith('collection-product-') ? document.getElementById(id) : null;
  };

  const restoreCollectionCard = () => {
    const card = getCollectionCardFromHash();
    if (card) card.scrollIntoView({ behavior: 'instant', block: 'center' });
  };

  const scheduleCollectionCardRestore = () => {
    requestAnimationFrame(() => requestAnimationFrame(restoreCollectionCard));
  };

  document.addEventListener(
    'click',
    (event) => {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        !(event.target instanceof Element)
      ) {
        return;
      }

      const link = event.target.closest('.collection-product-card a[href]');
      if (!link || (link.target && link.target !== '_self')) return;

      const destination = new URL(link.href, window.location.href);
      if (destination.origin !== window.location.origin || !destination.pathname.includes('/products/')) return;

      const card = link.closest('.collection-product-card[data-page][id]');
      if (!card) return;

      const collectionUrl = new URL(window.location.href);
      const page = Number(card.dataset.page);

      if (Number.isInteger(page) && page > 1) {
        collectionUrl.searchParams.set('page', String(page));
      } else {
        collectionUrl.searchParams.delete('page');
      }

      collectionUrl.hash = card.id;
      history.replaceState(history.state, '', collectionUrl);
    },
    true
  );

  addEventListener('pageshow', scheduleCollectionCardRestore);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleCollectionCardRestore, { once: true });
  } else {
    scheduleCollectionCardRestore();
  }
})();
